import {type MatrixClient} from 'matrix-js-sdk'
import {type UploadProgress} from 'matrix-js-sdk/lib/http-api/interface'

export type UploadResult = {
  contentUri: string // mxc:// URL
}

/**
 * Upload a file to the Matrix content repository.
 *
 * Web implementation: works with File/Blob directly.
 */
export async function uploadToMatrix(
  client: MatrixClient,
  file: {uri: string; name: string; type: string},
  onProgress?: (progress: UploadProgress) => void,
  abortController?: AbortController,
): Promise<UploadResult> {
  console.log(
    '[MatrixUpload] Starting upload:',
    file.name,
    file.type,
    file.uri.slice(0, 50),
  )
  let blob: Blob
  try {
    blob = await uriToBlob(file.uri)
    console.log(
      '[MatrixUpload] Blob created:',
      blob.size,
      'bytes, type:',
      blob.type,
    )
  } catch (e) {
    console.error('[MatrixUpload] Failed to create blob from URI:', e)
    throw e
  }
  try {
    const response = await client.uploadContent(blob, {
      name: file.name,
      type: file.type,
      progressHandler: onProgress,
      abortController,
    })
    console.log('[MatrixUpload] Upload success:', response.content_uri)
    return {contentUri: response.content_uri}
  } catch (e) {
    console.error('[MatrixUpload] uploadContent failed:', e)
    throw e
  }
}

async function uriToBlob(uri: string): Promise<Blob> {
  if (uri.startsWith('data:') || uri.startsWith('blob:')) {
    return fetch(uri).then(r => r.blob())
  }
  throw new TypeError(`Invalid upload URI on web: ${uri}`)
}
